import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-276cfe15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mg-12" }
const _hoisted_2 = { class: "formgrid formgroup-inline grid w-full flex justify-content-end flex-wrap" }

import { withDefaults } from "vue";
import Button from "primevue/button";

type IProps = {
  id: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'trash',
  props: {
    id: { default: 0 }
  },
  emits: ["trash"],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: number };





const onTrash = () => emits("trash", props.id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        class: "btn-trash hg-36 w-8rem text-center justify-content-center",
        icon: "icon-lms icon-lms_trash",
        label: "削除",
        onClick: onTrash
      })
    ])
  ]))
}
}

})